import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';
import { EMPTY_ID } from '@e-socna/empty-client';

import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';

export const MissionReportsPage_FindSomeReports_QueryDocument = graphql(`
  query MissionReportsPage_FindSomeReports_Query($filter: JSONObject!) {
    findSomeReports(filter: $filter) {
      _id
      code
      title
      templateId
      isEditable
      updatedAt
      contentUpdatedAt
      updaterId
      printing {
        pdfPrints {
          _id
          increment
          isTmp
          createdAt
          file {
            _id
            uri
          }
        }
      }
    }
  }
`);

export type MissionReportsPage_SomeReports = ResultOf<
  typeof MissionReportsPage_FindSomeReports_QueryDocument
>['findSomeReports'];

export const useFindAllMissionReportsQuery = (missionId = EMPTY_ID) =>
  useGraphQLQuery(
    MissionReportsPage_FindSomeReports_QueryDocument,
    { filter: { missionId } },
    { enabled: !!missionId },
  );
